export enum InterviewProcess {
  Accepted = 'Accepted',

  Rejected = 'Rejected',
}
